import { useState } from "react";
import Modal from "react-bootstrap/Modal";

export const RmaDetailPublish = () => {
    const [tab, setTab] = useState("tab-1");
    const [show, setShow] = useState(true);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    return (
        <>
            <Modal
                className="my_modal w_980"
                show={show}
                onHide={handleClose}
                centered
                size={"lg"}
            >
                <Modal.Header closeButton>
                    <Modal.Title>시리얼 번호 검증</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="modal_alert_primary mb-20px">
                        <img src={process.env.PUBLIC_URL + "/assets/images/icon_img_ok.png"} alt="" />
                        검증 성공 Serial
                    </div>
                    <div className="table_top">
                        <h6 className="table_stats">검증 성공 목록(<span>13</span>건)</h6>
                    </div>
                    <div className="table_scroll">
                        <table className="table table-bordered my_table table_modal m-0" style={{ minWidth: "unset" }}>
                            <colgroup>
                                <col style={{ width: "10.6%" }} />
                                <col style={{ width: "14.89%" }} />
                                <col style={{ width: "13.29%" }} />
                                <col style={{ width: "18.29%" }} />
                                <col style={{ width: "11.7%" }} />
                                <col style={{ width: "10.6%" }} />
                                <col style={{ width: "7.76%" }} />
                                <col />
                            </colgroup>
                            <thead>
                                <tr>
                                    <th>거래처 코드</th>
                                    <th>출고업체명</th>
                                    <th>규격</th>
                                    <th>Serial No</th>
                                    <th>출고일</th>
                                    <th>파일명</th>
                                    <th>QTY</th>
                                    <th>비고</th>
                                </tr>
                            </thead>
                            <tbody>
                                {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map(i => (
                                    <tr>
                                        <td className="text-center">000876</td>
                                        <td className="text-center">한주씨앤에스</td>
                                        <td className="text-center">6FA-00557</td>
                                        <td className="text-center">04537-010-002-767</td>
                                        <td className="text-center">2025-01-02</td>
                                        <td className="text-center">0101_(1)</td>
                                        <td className="text-center"></td>
                                        <td>비고내용</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="pagination-container mt-25px mb-15px">
                        <ul>
                            <li className="pg_nav">
                                <img
                                    src={process.env.PUBLIC_URL + "/assets/images/pg_first.png"}
                                    alt="First Page"
                                    className=""
                                />
                            </li>
                            <li className="pg_nav">
                                <img
                                    src={process.env.PUBLIC_URL + "/assets/images/pg_prev.png"}
                                    alt="Previous Page"
                                    className=""
                                />
                            </li>
                            <li className="active">1</li>
                            <li className="">2</li>
                            <li className="">3</li>
                            <li className="">4</li>
                            <li className="">5</li>
                            <li className="pg_nav">
                                <img
                                    src={process.env.PUBLIC_URL + "/assets/images/pg_next.png"}
                                    alt="Next Page"
                                    className=""
                                />
                            </li>
                            <li className="pg_nav">
                                <img
                                    src={process.env.PUBLIC_URL + "/assets/images/pg_last.png"}
                                    alt="Last Page"
                                    className=""
                                />
                            </li>
                        </ul>
                    </div>


                    <div className="modal_alert_danger mb-15px">
                        <img src={process.env.PUBLIC_URL + "/assets/images/icon_img_failure.png"} alt="" />
                        검증 실패 Serial
                    </div>

                    <div className="table_top">
                        <h6 className="table_stats">검증 실패 목록(<span>13</span>건)</h6>
                    </div>
                    <div className="row">
                        <div className="col-6">
                            <table className="table table-bordered my_table table_modal m-0">
                                <thead>
                                    <tr>
                                        <th>Serial No</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map(i => (
                                        <tr>
                                            <td className="text-center">04537-010-002-767</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div className="col-6">
                            <table className="table table-bordered my_table table_modal m-0">
                                <thead>
                                    <tr>
                                        <th>Serial No</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map(i => (
                                        <tr>
                                            <td className="text-center">04537-010-002-767</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="pagination-container mt-15px">
                        <ul>
                            <li className="pg_nav">
                                <img
                                    src={process.env.PUBLIC_URL + "/assets/images/pg_first.png"}
                                    alt="First Page"
                                    className=""
                                />
                            </li>
                            <li className="pg_nav">
                                <img
                                    src={process.env.PUBLIC_URL + "/assets/images/pg_prev.png"}
                                    alt="Previous Page"
                                    className=""
                                />
                            </li>
                            <li className="active">1</li>
                            <li className="">2</li>
                            <li className="">3</li>
                            <li className="">4</li>
                            <li className="">5</li>
                            <li className="pg_nav">
                                <img
                                    src={process.env.PUBLIC_URL + "/assets/images/pg_next.png"}
                                    alt="Next Page"
                                    className=""
                                />
                            </li>
                            <li className="pg_nav">
                                <img
                                    src={process.env.PUBLIC_URL + "/assets/images/pg_last.png"}
                                    alt="Last Page"
                                    className=""
                                />
                            </li>
                        </ul>
                    </div>
                </Modal.Body>
                <Modal.Footer className="border-0 pt-0">
                    <button
                        type="button"
                        className="btn btn-outline-secondary w-100px h-38px my-0"
                    ><img src={process.env.PUBLIC_URL + "/assets/images/icon_cross_grey.png"} alt="" />닫기</button>
                </Modal.Footer>
            </Modal>
            <div className="content_wrap">
                <div className="content_top">
                    <h3 className="filter_heading">RMA 상세보기</h3>
                    <div className="">
                    </div>
                    <div className="content_toolbar">
                        <button className="btn btn-outline-primary w-100px h-38px"><img src={process.env.PUBLIC_URL + "/assets/images/icon_hamburger_btn.png"} alt="" />목록</button>
                        <button className="btn btn-secondary w-100px h-38px">수정</button>
                    </div>
                </div>
                <h5 className="subheading">RMA 기본정보</h5>

                <table className="table table-bordered my_table table_detail">
                    <tbody>
                        <tr>
                            <th style={{ width: "16.66%" }}>RMA 번호</th>
                            <td style={{ width: "16.66%" }}>123456814</td>
                            <th style={{ width: "16.66%" }}>RMA 일자</th>
                            <td style={{ width: "16.66%" }}>2024.01.01</td>
                            <th style={{ width: "16.66%" }}>규격</th>
                            <td>MUV-00028</td>
                        </tr>
                        <tr>
                            <th>COA</th>
                            <td>TN COA</td>
                            <th>수량</th>
                            <td>3EA</td>
                            <th>상태</th>
                            <td>진행</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className="mybtns_group">
                <div className="btn-group" role="group" aria-label="">
                    <button type="button" className={tab == "tab-1" ? "btn btn-light active" : "btn btn-light"} onClick={() => setTab("tab-1")}>RMA 정보</button>
                    <button type="button" className={tab == "tab-2" ? "btn btn-light active" : "btn btn-light"} onClick={() => setTab("tab-2")}>고객정보</button>
                    <button type="button" className={tab == "tab-3" ? "btn btn-light active" : "btn btn-light"} onClick={() => setTab("tab-3")}>기본정보</button>
                </div>
                <div className="mybtns_group_toolbar">
                    <button type="button" className="btn btn-dark w-150px px-0"><img src={process.env.PUBLIC_URL + "/assets/images/icon_export.png"} alt="" />엑셀 내보내기</button>
                    <button className="btn btn-outline-primary">Serial 검증</button>
                </div>

            </div>

            {tab == "tab-1" && <div className="content_wrap">
                <div className="table_scroll m-0">
                    <table className="table table-bordered my_table">
                        <thead>
                            <tr>
                                <th style={{ width: "4.4%" }}>NO</th>
                                <th style={{ width: "10.56%" }}>End Item Number</th>
                                <th style={{ width: "10.56%" }}>COA Base Stock</th>
                                <th style={{ width: "13.64%" }}>Beginning COA Number *</th>
                                <th style={{ width: "11%" }}>Ending COA Number</th>
                                <th style={{ width: "7.5%" }}>Quantity</th>
                                <th style={{ width: "10.56%" }}>Original PO</th>
                                <th style={{ width: "10.56%" }}>Return Reason</th>
                                <th style={{ width: "10.56%" }}>Comments</th>
                                <th>Received Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {[0, 1, 2].map((item) => (<tr>
                                <td className="text-center">{item + 1}</td>
                                <td className="text-center">MUV-00028</td>
                                <td className="text-center"></td>
                                <td className="text-center"></td>
                                <td className="text-center"></td>
                                <td className="text-center">1</td>
                                <td className="text-center"></td>
                                <td className="text-center">Damaged...</td>
                                <td className="text-center"></td>
                                <td className="text-center"></td>
                            </tr>))}
                        </tbody>
                    </table>
                </div>
            </div>}

            {tab == "tab-2" && <div className="content_wrap">
                <div className="table_scroll m-0">
                    <table className="table table-bordered my_table table_detail">
                        <tbody>
                            <tr>
                                <th style={{ width: "16.7%" }}>거래처</th>
                                <td style={{ width: "33.33%" }}>(주) 구구구</td>
                                <th style={{ width: "8.3%" }}></th>
                                <th style={{ width: "8.3%" }}>성함</th>
                                <td>김길동 대리</td>
                            </tr>
                            <tr>
                                <th>RMA 일자</th>
                                <td>2024.05.04</td>
                                <th>연락처</th>
                                <th>전화번호</th>
                                <td>010-1111-1111</td>
                            </tr>
                            <tr>
                                <th>벤더</th>
                                <td>MS</td>
                                <th></th>
                                <th>이메일</th>
                                <td>leeeeeeeeeee1234@it.com</td>
                            </tr>
                            <tr>
                                <th>카테고리</th>
                                <td>Std</td>
                                <th colSpan={2}>담당자 <span className="required">*</span></th>
                                <td>담당자</td>
                            </tr>
                            <tr>
                                <th>품목명</th>
                                <td>S1-WIN Pro-E7 SP1 32-64b</td>
                                <th colSpan={2}>수량</th>
                                <td>3</td>
                            </tr>
                            <tr>
                                <th>규격</th>
                                <td colSpan={5}>MUV-00028</td>
                            </tr>
                            <tr>
                                <th>COA</th>
                                <td colSpan={5}>TN COA</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>}

            {tab == "tab-3" && <div className="content_wrap">
                <div className="table_scroll m-0">
                    <table className="table table-bordered my_table table_detail">
                        <tbody>
                            <tr>
                                <th style={{ width: "16.66%" }}>Distributor Name</th>
                                <td colSpan={3}>MDS Tech</td>
                            </tr>
                            <tr>
                                <th>MS Sold to Number</th>
                                <td>0000054136</td>
                                <th style={{ width: "16.66%" }}>Agreement Number</th>
                                <td>54130007</td>
                            </tr>
                            <tr>
                                <th>Contact Information</th>
                                <td>Sohee Lee</td>
                                <td>+82-31-602-1234</td>
                                <td>Sohee.lee@mdstech.co.kr</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>}
        </>
    );
}